// src/assets/icons/Agent.jsx
import React from 'react';

const Agent = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.57087 10.7143C10.9378 10.7143 12.8566 8.79551 12.8566 6.42857C12.8566 4.06164 10.9378 2.14286 8.57087 2.14286C6.20394 2.14286 4.28516 4.06164 4.28516 6.42857C4.28516 8.79551 6.20394 10.7143 8.57087 10.7143Z" stroke="white" strokeOpacity="0.7" strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.71456 9.78588C4.86237 10.1901 4.14189 10.8271 3.63633 11.6234C3.13076 12.4197 2.86073 13.3427 2.85742 14.2859C2.85742 14.4753 2.93268 14.657 3.06663 14.791C3.20059 14.9249 3.38227 15.0002 3.57171 15.0002H13.5717C13.7611 15.0002 13.9428 14.9249 14.0768 14.791C14.2107 14.657 14.286 14.4753 14.286 14.2859C14.2867 13.339 14.0186 12.4114 13.5128 11.611C13.007 10.8106 12.2843 10.1702 11.4289 9.76445" stroke="white" strokeOpacity="0.7" strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Agent;
